<div class="form-field">
  <input matInput
         type="text"
         i18n-placeholder="@@core.toc.filter"
         placeholder="Filter by layer name or keywords..."
         tmAutoFocus
         [formControl]="filterControl" />
</div>
